import { Global, css } from '@emotion/react';
import styled from '@emotion/styled';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import DirectTorque from './pages/DirectTorque';
import MotionPro from './pages/MotionPro';
import About from './pages/About';

const globalStyles = css`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    background: #121212;
    color: white;
  }
`;

const AppContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #121212 0%, #1a1a1a 100%);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, #ff6b00, transparent);
  }
`;

function App() {
  return (
    <Router>
      <Global styles={globalStyles} />
      <AppContainer>
        <Navbar />
        <Routes>
          <Route path="/" element={<Hero />} />
          <Route path="/directtorque" element={<DirectTorque />} />
          <Route path="/motionpro" element={<MotionPro />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </AppContainer>
    </Router>
  );
}

export default App;
